import { render, staticRenderFns } from "./TilledNewCard.vue?vue&type=template&id=2ab1b2ce"
import script from "./TilledNewCard.vue?vue&type=script&lang=js"
export * from "./TilledNewCard.vue?vue&type=script&lang=js"
import style0 from "./TilledNewCard.vue?vue&type=style&index=0&id=2ab1b2ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports